<template>
  <b-modal
    id="scan-result-modal"
    ref="modal"
    centered
    class="scan-result-full-screen-modal"
    header-class="scan-result-modal-header"
  >

    <template #modal-header="{ close }">
      <div class="scan-result-modal-header-content step4 w-100">
        <img
          :src="isSuccess ? require(`@/assets/images/b122/ic_investigator_gifts.png`) : require(`@/assets/images/b122/img-watcher-right.png`)"
          class="scan-result-modal-img">
        <div class="scan-result-container h-100">
          <h1 :class="(isSuccess ? 'green-o' : 'red-o') + ' page-title ml-4 scan-result-modal-subtitle '"
              v-html="isSuccess ? $t('scan.result.modal.success.title') : $t('scan.result.modal.fail.title')"/>
        </div>
      </div>
    </template>

    <!--region fail-->
    <div v-if="!isSuccess">
      <p v-if="hasGainedLampion" class="content">{{ $t('scan.result.modal.fail.lampion.gain') }}</p>
      <p class="main-grey-light-color">{{ $t('scan.result.modal.fail.description') }}</p>
    </div>
    <!--endregion-->

    <!--region identifiant   -->
    <div class="d-flex align-items-center justify-content-center">
      <span>{{ $t('scan.result.modal.information.given') }}</span>
    </div>
    <div>
      <div class="card-plate mb-3">
        {{ identifier }}
      </div>
    </div>
    <!--endregion -->

    <!--region insist description-->
    <div v-if="shouldDisplayInsistButton">
      <p class="content" v-html="$t('scan.result.modal.fail.insist.text')"></p>
    </div>
    <!--endregion-->

    <!--region success-->
    <div v-if="isSuccess">
      <p class="bold-text main-red-color">{{ $t('scan.result.modal.caution') }}</p>
    </div>
    <!--endregion-->

    <!--region disclaimer-->
    <div v-if="isSuccess || shouldDisplayInsistButton">
      <a class="main-color link" @click="onFraudClicked">{{ $t('scan.result.modal.disclaimer') }}</a>
    </div>
    <!--endregion-->

    <template #modal-footer="{ ok, cancel, hide }">
      <div class="w-100 d-flex">
        <b-button v-if="shouldDisplayInsistButton" class="w-100 mr-2" variant="secondary"
                  @click="onInsistClicked($event)">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{ $t('scan.result.modal.fail.insist') }}</span>
          </div>
        </b-button>
        <b-button class="w-100" variant="primary" @click="isSuccess ? onVerifyClicked($event) : onEndClicked($event)">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">
              {{ isSuccess ? $t('scan.result.modal.success.button.text') : $t('Finish') }}</span>
          </div>
        </b-button>
      </div>
    </template>

  </b-modal>
</template>

<script>
export default {
  props: {
    isSuccess: Boolean,
    shouldDisplayInsistButton: Boolean,
    identifier: String,
    hasGainedLampion: Boolean,
  },

  emits: [
    'onVerifyClicked',
    'onInsistClicked',
    'onEndClicked'
  ],

  data() {
    return {};
  },

  methods: {
    onInsistClicked() {
      this.$emit('onInsistClicked')
    },

    onVerifyClicked() {
      this.$emit('onVerifyClicked')
    },

    onEndClicked() {
      this.$emit('onEndClicked')
    },

    onFraudClicked() {
      window.open('https://www.legifrance.gouv.fr/codes/section_lc/LEGITEXT000006070719/LEGISCTA000006149854/#LEGISCTA000006149854', '_blank');
    }
  },
};
</script>

<!-- not scoped car modal -->
<style>

#scan-result-modal .modal-header {
  background-color: var(--main-black-light) !important;
  padding-bottom: 0;
}

#scan-result-modal .modal-content,
#scan-result-modal .modal-body,
#scan-result-modal .modal-footer {
  background-color: var(--main-black-dark);
}

.scan-result-modal-subtitle {
  text-align: right;
}

#scan-result-modal .scan-result-modal-header-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-bottom: none;
}

.scan-result-modal-img {
  max-width: 200px;
  min-width: 100px;
  z-index: 1;
}

#scan-result-modal .modal-text {
  color: var(--main-grey-medium);
}

.scan-result-modal-header {
  background-color: var(--main-black-medium) !important;
  position: relative;
  margin-top: -20px;
  margin-right: -20px;
  margin-left: -20px;
}

.scan-result-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  flex-direction: column;
}

#scan-result-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}

.scan-result-full-screen-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
}

.scan-result-full-screen-modal .modal-content {
  height: auto;
  border-radius: 30px;
}

.green-o {
  color: var(--main-green-medium) !important;
}

.red-o {
  color: var(--main-red-medium) !important;
}

.link {
  color: var(--main-yellow-medium);
  text-decoration: underline;
  cursor: pointer;
}

@media (max-width: 991px) {
  .scan-result-container img {
    order: 2;
    align-self: center;
  }

  .scan-result-container {
    flex-direction: column;
    text-align: center;
  }
}

@media (max-width: 767px) {
  #scan-result-modal .modal-content {
    display: flex;
    overflow: auto;
    padding: 10px;
  }

  #scan-result-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #scan-result-modal .modal-header {
    padding-top: 0;
  }

  .scan-result-modal-img {
    margin-top: 20px;
    align-self: end;
  }

  .scan-result-modal-subtitle {
    margin-top: 6px !important;
    margin-left: 0 !important;
  }

  #scan-result-modal .modal-content {
    margin: 8px;
  }

  #scan-result-modal .modal-text, #scan-result-modal .scan-result-container {
    padding: 10px;
  }

  #scan-result-modal .scan-result-modal-img {
    max-width: 100px;
  }
}


</style>



// WEBPACK FOOTER //
// src/views/match/ScanResultModal.vue